// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.walletRadarAddresses_walletRadarAddressesComponent__zYbRz {
    background: #F0F0F3;
    /* transition: background-color 0.3s ease; */
    /* height: 380px;
    max-width: 240px ; */

}

.walletRadarAddresses_walletRadarAddressesComponent__zYbRz:nth-child(odd) {
    background: #8484840D;

}

/* .staking_card_product_title {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    padding-left: 10px;
    width: 118px;
    color: #364048;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
} */

/* 
.staking_card_product_level {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    padding-right: 10px;
    text-align: right;
    color: #4DC7B5;
    white-space: nowrap;
} */

.walletRadarAddresses_double_arrow__GaGQf {
    background-color: #F0F0F3;
    width: 24px;
    height: 24px;
    border-radius: 30px;
    box-shadow: 3px 3px 8px 0px #AEAEC066;
    margin: 0 auto;
    text-align: center;
    line-height: 30px;
    display: none;
    position: absolute;
    bottom: -15px;
    left: 0;
    right: 0;
    cursor: pointer;
    transition: transform 0.5s ease;
    z-index: 10;
}

.walletRadarAddresses_walletRadarAddressesComponent__zYbRz:hover, .walletRadarAddresses_walletRadarAddressesComponent__zYbRz:hover .walletRadarAddresses_double_arrow__GaGQf {
    display: block;
    /* background: #FDFDFD; */
}

/* .walletRadarAddressesComponent {
    height: 98px;
    border-radius: 16px;
    box-shadow: -5px -5px 5px 0px rgba(255, 255, 255, 0.7490196078) inset, 5px 5px 5px 0px rgba(174, 174, 192, 0.2) inset;
    width: 100%;
    overflow-y: auto;
    transition: height 0.5s ease;
} */

.walletRadarAddresses_walletRadarAddressesComponent__zYbRz.walletRadarAddresses_expanded__jqsuw {
    height: 260px;
    position: relative;
    top: 0;
    z-index: 10;
    background: #f0f0f3;
    overflow: auto;
}

.walletRadarAddresses_double_arrow__GaGQf.walletRadarAddresses_rotate__yLDi2 {
    transform: rotate(180deg);
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/Components/WalletRadarAddresses/walletRadarAddresses.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C;wBACoB;;AAExB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;;;;;;;;;;GAUG;;AAEH;;;;;;;;;GASG;;AAEH;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,eAAe;IACf,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;;;;;GAOG;;AAEH;IACI,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".walletRadarAddressesComponent {\n    background: #F0F0F3;\n    /* transition: background-color 0.3s ease; */\n    /* height: 380px;\n    max-width: 240px ; */\n\n}\n\n.walletRadarAddressesComponent:nth-child(odd) {\n    background: #8484840D;\n\n}\n\n/* .staking_card_product_title {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-left: 10px;\n    width: 118px;\n    color: #364048;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n} */\n\n/* \n.staking_card_product_level {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-right: 10px;\n    text-align: right;\n    color: #4DC7B5;\n    white-space: nowrap;\n} */\n\n.double_arrow {\n    background-color: #F0F0F3;\n    width: 24px;\n    height: 24px;\n    border-radius: 30px;\n    box-shadow: 3px 3px 8px 0px #AEAEC066;\n    margin: 0 auto;\n    text-align: center;\n    line-height: 30px;\n    display: none;\n    position: absolute;\n    bottom: -15px;\n    left: 0;\n    right: 0;\n    cursor: pointer;\n    transition: transform 0.5s ease;\n    z-index: 10;\n}\n\n.walletRadarAddressesComponent:hover, .walletRadarAddressesComponent:hover .double_arrow {\n    display: block;\n    /* background: #FDFDFD; */\n}\n\n/* .walletRadarAddressesComponent {\n    height: 98px;\n    border-radius: 16px;\n    box-shadow: -5px -5px 5px 0px rgba(255, 255, 255, 0.7490196078) inset, 5px 5px 5px 0px rgba(174, 174, 192, 0.2) inset;\n    width: 100%;\n    overflow-y: auto;\n    transition: height 0.5s ease;\n} */\n\n.walletRadarAddressesComponent.expanded {\n    height: 260px;\n    position: relative;\n    top: 0;\n    z-index: 10;\n    background: #f0f0f3;\n    overflow: auto;\n}\n\n.double_arrow.rotate {\n    transform: rotate(180deg);\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"walletRadarAddressesComponent": `walletRadarAddresses_walletRadarAddressesComponent__zYbRz`,
	"double_arrow": `walletRadarAddresses_double_arrow__GaGQf`,
	"expanded": `walletRadarAddresses_expanded__jqsuw`,
	"rotate": `walletRadarAddresses_rotate__yLDi2`
};
export default ___CSS_LOADER_EXPORT___;
